// 惠企平台
import LatestPolicyManage from '../view/EnterpriseFavour/LatestPolicy/LatestPolicyManage'
import LatestPolicyCurrent from '../view/EnterpriseFavour/LatestPolicy/LatestPolicyCurrent'
import HotspotIssuesManage from '../view/EnterpriseFavour/HotspotIssues/HotspotIssuesManage'
import HotspotIssuesCurrent from '../view/EnterpriseFavour/HotspotIssues/HotspotIssuesCurrent'
import LiveRoomManage from '../view/EnterpriseFavour/LiveRoom/LiveRoomManage'
import LiveRoomCurrent from '../view/EnterpriseFavour/LiveRoom/LiveRoomCurrent'
import EnterpriseFavourNav from '../view/EnterpriseFavour/EnterpriseFavourNav'

export default [
    /* 惠企服务 */
    {
        path: '/latest_policy_manage',
        name: 'latest-policy-manage',
        components: {
            default: EnterpriseFavourNav,
            a: LatestPolicyManage
        }
    },
    {
        path: '/latest_policy_current/:id',
        name: 'latest-policy-current',
        components: {
            default: EnterpriseFavourNav,
            a: LatestPolicyCurrent
        }
    },
    {
        path: '/hotspot_issues_manage',
        name: 'hotspot-issues-manage',
        components: {
            default: EnterpriseFavourNav,
            a: HotspotIssuesManage
        }
    },
    {
        path: '/hotspot_issues_current/:id',
        name: 'hotspot-issues-current',
        components: {
            default: EnterpriseFavourNav,
            a: HotspotIssuesCurrent
        }
    },
    {
        path: '/live_room_manage',
        name: 'live-room-manage',
        components: {
            default: EnterpriseFavourNav,
            a: LiveRoomManage
        }
    },
    {
        path: '/live_room_current/:id',
        name: 'live-room-current',
        components: {
            default: EnterpriseFavourNav,
            a: LiveRoomCurrent
        }
    },
    /* 惠企服务 */
]


// WEBPACK FOOTER //
// ./src/router/EnterpriseFavour.js